import {FC, useEffect, useState} from "react";
import {atom, selector, useRecoilState, useRecoilValue} from "recoil";
import {DefaultLocalizations} from "./Localizations";
import {AppDataAtom} from "../access/ApplicationDataProvider";
import {merge} from "lodash";
import {LocalizationsType} from "./LocalizationsType";

const LOCALE_UNSET = 'unset';

export const LocaleAtom = atom<string>({
   key: 'Locale',
   default: LOCALE_UNSET
});

export const LocalizationsAtom = selector<LocalizationsType>({
   key: 'LocalizationsSelector',
   get: ({get}) => {
      const locale = get(LocaleAtom)
      const appData = get(AppDataAtom);

      const effectiveLocale = locale === LOCALE_UNSET ? 'en' : locale;
      let defaultLocalizations = (DefaultLocalizations as any)[effectiveLocale];
      if (!defaultLocalizations) {
         defaultLocalizations = (DefaultLocalizations as any)['en']
      }

      let localizations = appData.localizations.filter(loc => loc.language === locale).reduce((rv: any, x: any) => {
         const {language, ...rest} = x;
         (rv = rv || {})[rest.key] = rest.value
         return rv;
      }, {});

      let spreadElements = {...merge(defaultLocalizations, localizations)};
      return {
         ...spreadElements,
         formatString: (s1, ...val: string[]) => {
            let str = s1;
            for (let index = 0; index < val.length; index++) {
               str = str.replace(`{${index}}`, val[index]);
            }
            return str;
         },
         getString: (key: string, def?: string) => {
            return spreadElements[key] || def
         }
      };
   }
})

export const LocalizationProvider: FC<any> = ({children}) => {
   const [current, setCurrent] = useState<string>('')
   const [locale, setLocale] = useRecoilState(LocaleAtom);
   const appData = useRecoilValue(AppDataAtom);

   useEffect(() => {
      if (locale === LOCALE_UNSET) {
         const lang = window.Shopify?.locale || window.tradeInSession?.language || document.documentElement.lang;
         if (appData.languages.includes(lang)) {
            setLocale(lang);
         } else {
            setLocale(appData.languages[0]);
         }
      } else {
         setCurrent(locale);
      }
   }, [locale, setLocale, appData])

   if (locale === current) {
      return children
   } else {
      return null
   }
}
